import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const mainCover = 'https://cdn.magicpatterns.com/uploads/9igeQHSpmhprGitpqpDCso/01_cover.png';
const buyers = [{
  name: 'María',
  age: 34
}, {
  name: 'Carlos',
  age: 41
}, {
  name: 'Ana',
  age: 28
}, {
  name: 'Lucía',
  age: 37
}, {
  name: 'Diego',
  age: 45
}, {
  name: 'Sofía',
  age: 31
}, {
  name: 'Andrés',
  age: 39
}, {
  name: 'Valentina',
  age: 26
}, {
  name: 'Roberto',
  age: 52
}, {
  name: 'Carmen',
  age: 43
}, {
  name: 'Miguel',
  age: 36
}, {
  name: 'Laura',
  age: 29
}, {
  name: 'Fernando',
  age: 47
}, {
  name: 'Julieta',
  age: 33
}, {
  name: 'Martín',
  age: 38
}];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    age: 0,
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const city = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: buyer.name,
        age: buyer.age,
        city
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const intervalId = setInterval(() => {
      if (!isVisible) {
        const delay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
        setTimeout(showPopup, delay);
      }
    }, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-159">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-warm-400 rounded-xl p-3 shadow-xl max-w-sm" data-id="element-160">
          <div className="flex items-center gap-3" data-id="element-161">
            <img src={mainCover} alt="Air Fryer Fácil" className="w-14 h-14 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-162" />
            <div className="flex-1 min-w-0" data-id="element-163">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-164">
                <CheckCircle2Icon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-165" />
                <p className="text-sm text-warm-900 font-bold truncate" data-id="element-166">
                  {currentBuyer.name}, {currentBuyer.age} años
                </p>
              </div>
              <p className="text-xs text-warm-700" data-id="element-167">
                de {currentBuyer.city}, Argentina
              </p>
              <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-168">
                acaba de comprar este producto
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}